<template>
	<b-form-group>
		<template v-slot:label>
			{{ label }}
		</template>
		<b-input-group size="sm">
			<b-form-input
				type="text"
				size="sm"
				:value="place.name"
				readonly
				required
			/>

			<template v-slot:prepend>
				<b-button
					v-if="locationUrl"
					:href="locationUrl"
					target="_blank"
					variant="success"
					size="sm"
					v-b-tooltip.hover 
					:title="$t('tooltips.viewLocation')"
				>
					<md-icon :icon="placeTypeIcon" />
				</b-button>
				<b-input-group-text v-else
					><md-icon :icon="placeTypeIcon"
				/></b-input-group-text>
			</template>
		</b-input-group>
	</b-form-group>
</template>

<script>

export default {
	props: {
		label: String,
		index: Number,
		place: Object,
		placeId: [Number, String],
	},
	data: () => ({
		editable: false,
		search: "",
		loading: false,
		searchData: []
	}),
	computed: {
		locationUrl() {
			if (this.place.latitude && this.place.longitude) {
				return `https://www.google.com/maps/search/?api=1&query=${this.place.latitude},${this.place.longitude}`;
			} else {
				return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
					this.place.name
				)}`;
			}
		},
		placeTypeIcon() {
			let icon = "location_on";
			if (this.place.isAirport) icon = "flight";
			return icon;
		},
		placeHasValidLocation() {
			return (
				this.place.latitude !== null && this.place.longitude !== null
			);
		}
	},
	methods: {
	}
};
</script>
